"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _AuComponent = _interopRequireDefault(require("./AuComponent"));
var styles = {
  "title": "area_chart-module__title___c2x7R",
  "container": "area_chart-module__container___fXmRU",
  "tooltip": "area_chart-module__tooltip___wLE64",
  "tooltip_circle": "area_chart-module__tooltip_circle___Zyp3f",
  "tooltip_bold": "area_chart-module__tooltip_bold___YZ2nh",
  "tooltip_text": "area_chart-module__tooltip_text___I6Jpd",
  "tooltip_link": "area_chart-module__tooltip_link___fXyqY"
};
class RechartsTooltip extends _AuComponent.default {
  render() {
    const {
      payload
    } = this.props;
    if (payload && payload[0]) {
      let defs = [];
      for (let each in payload) {
        const def = /*#__PURE__*/_react.default.createElement("div", {
          key: each
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: styles.tooltip_circle,
          style: {
            backgroundColor: payload[each].stroke
          }
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: styles.tooltip_text
        }, payload[each].name, ": ", payload[each].value));
        defs.push(def);
      }
      const tooltip = /*#__PURE__*/_react.default.createElement("div", {
        className: styles.tooltip
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: styles.tooltip_bold
      }, payload[0].payload.name), defs);
      return tooltip;
    }
    return null;
  }
}
exports.default = RechartsTooltip;